var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.006,
    y1: -0.031,
    x2: 1.002,
    y2: 1.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M46,43.778A2.222,2.222,0,0,1,43.778,46H8.222A2.222,2.222,0,0,1,6,43.778V8.222A2.222,2.222,0,0,1,8.222,6H43.778A2.222,2.222,0,0,1,46,8.222Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M25.444,41V28.773H21V22.106h4.444V19.731c0-5.6,2.962-8.687,8.339-8.687a28.556,28.556,0,0,1,4,.231l.953.123.043.957v5.307H34.739c-1.253,0-1.517,1.531-1.517,2.817v1.628H38.47l-1.031,6.667H33.222V41Z",
    transform: "translate(1.667 0.56)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M25.944,40.384V28.162H21.5V22.606h4.444V19.675c0-5.32,2.691-8.131,7.783-8.131a28.154,28.154,0,0,1,3.933.227l.484.063.022.491v4.726H34.684c-1.8,0-2.072,2.112-2.072,3.372v2.183h5.156l-.859,5.556h-4.3V40.384Z",
    transform: "translate(1.722 0.616)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M34.628,16.44h2.928V12.269a27.454,27.454,0,0,0-3.883-.226c-4.557,0-7.228,2.311-7.228,7.577v3.487H22v4.444h4.444V39.773H32V27.551h4.376l.687-4.444H32V20.367C32,18.285,32.68,16.44,34.628,16.44Z",
    transform: "translate(1.778 0.671)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.0ec33b684ebf9789ff71313acb979765.svg";
export { ForwardRef as ReactComponent };